import { ShieldCheck, Phone, MessageCircle } from "lucide-react";
import { Eyebrow, MaskHeading, Reveal, Gold } from "./Motion";
import { DistributorForm } from "./DistributorForm";
import { CONTACT } from "./data";

export const Distributor = () => (
  <section id="distributor" data-testid="distributor-section" className="relative bg-ns-cream py-24 md:py-36">
    <div className="mx-auto grid max-w-[1400px] gap-14 px-5 sm:px-8 lg:grid-cols-12 lg:gap-16">
      <div className="lg:col-span-5">
        <div className="lg:sticky lg:top-32">
          <Eyebrow testId="distributor-eyebrow">05 / Join the Network</Eyebrow>
          <MaskHeading
            testId="distributor-heading"
            className="mt-6 font-serif text-5xl font-semibold leading-[0.98] text-ns-emerald sm:text-7xl lg:text-[5.2rem]"
            lines={["Your next", <Gold key="g">big move</Gold>, "starts here."]}
          />
          <Reveal>
            <p data-testid="distributor-supporting-copy" className="mt-8 max-w-md text-base leading-relaxed text-ns-muted">
              Join our expanding distribution network across Bihar and nationwide. Tell us a little about your business and our team will reach out.
            </p>
            <p data-testid="distributor-trust-note" className="mt-8 flex items-center gap-3 rounded-full border border-ns-emerald/15 bg-white/70 px-5 py-3 text-sm font-medium text-ns-emerald sm:inline-flex">
              <ShieldCheck className="h-5 w-5 shrink-0 text-ns-bronze" />
              Applications are reviewed by our sales leadership team
            </p>
            <p data-testid="distributor-sales-contact" className="mt-10 text-sm text-ns-muted">
              Orders & distribution inquiries: <span className="font-semibold text-ns-emerald">{CONTACT.salesContact}</span>
            </p>
            <div className="mt-4 flex flex-col gap-3 sm:flex-row">
              <a href={CONTACT.phoneHref} data-testid="distributor-call-link" className="inline-flex items-center gap-2 text-sm font-semibold text-ns-emerald link-underline">
                <Phone className="h-4 w-4 text-ns-bronze" /> {CONTACT.phone}
              </a>
              <a href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer" data-testid="distributor-whatsapp-link" className="inline-flex items-center gap-2 text-sm font-semibold text-ns-emerald link-underline sm:ml-6">
                <MessageCircle className="h-4 w-4 text-ns-bronze" /> WhatsApp {CONTACT.phone2}
              </a>
            </div>
          </Reveal>
        </div>
      </div>
      <Reveal className="lg:col-span-7">
        <div className="relative rounded-[32px] border-t-4 border-ns-gold bg-white p-6 shadow-[0_50px_100px_-50px_rgba(11,60,42,0.45)] sm:p-10">
          <DistributorForm />
        </div>
      </Reveal>
    </div>
  </section>
);
